(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-media-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kf-card-loop')) {
  customElements.define('kf-card-loop', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('.kf-loop-track');
      if (!this.track) return;
      this.cards = Array.from(this.track.children);
      this.viewport = this.querySelector('.kf-loop-viewport');
      this.controls = this.querySelector('.kf-loop-controls');
      this.button = this.querySelector('.kf-loop-toggle');
      this.label = this.querySelector('[data-loop-label]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.sequence = 0;
      this.visible = true;
      this.userPaused = false;
      this.button.setAttribute('aria-pressed', 'false');
      this.label.textContent = this.dataset.pauseLabel;
      this.hovered = false;
      this.focused = false;
      this.editorPaused = false;
      this.touched = false;
      this.listeners = [];
      const listen = (target, name, fn, options) => {
        target.addEventListener(name, fn, options);
        this.listeners.push(() => target.removeEventListener(name, fn, options));
      };
      const sync = () => this.schedule();
      listen(this, 'pointerenter', e => { if(e.pointerType === 'mouse') { this.hovered = true; this.stop(); } });
      listen(this, 'pointerleave', e => { if(e.pointerType === 'mouse') { this.hovered = false; sync(); } });
      listen(this, 'pointerdown', e => { this.touchStart = e.target.closest('video,button,a,input,select') ? null : e.clientX; this.touched = true; this.stop(); });
      listen(window, 'pointerup', e => { if(this.touched) { this.touched = false; const delta = this.touchStart === null ? 0 : e.clientX - this.touchStart; this.touchStart = null; if(Math.abs(delta) > 40) this.advance(delta < 0 ? 1 : -1, true); else sync(); } });
      listen(window, 'pointercancel', () => { this.touched = false; sync(); });
      listen(this, 'focusin', e => { if(!this.button.contains(e.target)) { this.focused = true; this.stop(); } });
      listen(this, 'focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement) && !this.button.contains(document.activeElement); sync(); }));
      listen(this.button, 'click', () => {
        this.userPaused = !this.userPaused;
        this.button.setAttribute('aria-pressed', String(this.userPaused));
        this.label.textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        if(this.userPaused) this.stop(); else sync();
      });
      listen(document, 'visibilitychange', () => { if(document.hidden) this.stop(); else sync(); });
      listen(this, 'play', () => this.stop(), true);
      listen(this, 'pause', sync, true);
      listen(this, 'ended', sync, true);
      listen(this.reduced, 'change', () => this.configure());
      listen(this, 'shopify:block:select', e => {
        this.editorPaused = true; this.stop();
        const selected = this.cards.find(card => card === e.target || card.contains(e.target));
        if(selected && this.classList.contains('is-ready')) {
          while(this.track.firstElementChild !== selected) this.track.append(this.track.firstElementChild);
        }
      });
      listen(this, 'shopify:block:deselect', () => { this.editorPaused = false; sync(); });
      const section = this.closest('.shopify-section');
      if(section) {
        listen(section, 'shopify:section:select', () => { this.editorPaused = true; this.stop(); });
        listen(section, 'shopify:section:deselect', () => { this.editorPaused = false; sync(); });
      }
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if(this.visible) sync(); else this.stop();
      }, {threshold:0.05});
      this.observer.observe(this);
      this.resizeObserver = new ResizeObserver(() => { this.stop(); sync(); });
      this.resizeObserver.observe(this.viewport);
      this.cleanup = () => {
        this.stop();
        this.listeners.forEach(remove => remove());
        this.observer.disconnect(); this.resizeObserver.disconnect();
        this.cards.forEach(card => this.track.append(card));
        this.classList.remove('is-ready');
        this.cleanup = null;
      };
      this.configure();
    }
    disconnectedCallback() { if(this.cleanup) this.cleanup(); }
    configure() {
      this.stop();
      const enabled = this.dataset.enabled !== 'false' && this.cards.length > 1 && !this.reduced.matches && typeof this.track.animate === 'function';
      this.classList.toggle('is-ready', enabled);
      this.style.setProperty('--kf-loop-columns', Math.min(3, this.cards.length));
      this.controls.hidden = !enabled;
      if(!enabled) this.cards.forEach(card => this.track.append(card));
      this.schedule();
    }
    canRun() {
      return this.isConnected && this.classList.contains('is-ready') && this.visible && !document.hidden && !this.userPaused && !this.hovered && !this.focused && !this.editorPaused && !this.touched && !Array.from(this.querySelectorAll('video')).some(video => !video.paused && !video.ended);
    }
    schedule() {
      clearTimeout(this.timer);
      if(!this.canRun() || this.busy) return;
      this.timer = setTimeout(() => this.advance(), Math.max(2, Number(this.dataset.interval) || 4) * 1000);
    }
    stop() {
      clearTimeout(this.timer);
      this.sequence++;
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      if(this.clone) this.clone.remove();
      this.clone = null;
      this.busy = false;
    }
    advance(direction = 1, manual = false) {
      if(this.busy || !this.classList.contains('is-ready') || (!manual && !this.canRun())) return;
      const first = direction === 1 ? this.track.firstElementChild : this.track.lastElementChild;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = first.getBoundingClientRect().width + gap;
      if(distance <= gap) { this.schedule(); return; }
      this.busy = true;
      const sequence = ++this.sequence;
      const duration = Math.max(400, Number(this.dataset.duration) || 1000);
      this.clone = first.cloneNode(true);
      this.clone.setAttribute('aria-hidden', 'true');
      this.clone.setAttribute('inert', '');
      [this.clone, ...this.clone.querySelectorAll('*')].forEach(node => {
        node.removeAttribute('id');
        Array.from(node.attributes).forEach(attr => { if(attr.name.startsWith('data-shopify')) node.removeAttribute(attr.name); });
      });
      this.clone.querySelectorAll('video').forEach(video => { video.removeAttribute('autoplay'); video.removeAttribute('controls'); video.preload = 'none'; });
      if(direction === 1) this.track.append(this.clone); else this.track.prepend(this.clone);
      const frames = [{transform:'translateX(0)'},{transform:`translateX(-${distance}px)`}];
      if(direction === -1) frames.reverse();
      const motion = this.track.animate(frames, {duration, easing:'cubic-bezier(.22,.68,.2,1)', fill:'forwards'});
      this.animations = [motion];
      Array.from(this.track.children).forEach((card, index) => {
        if(index > 4) return;
        const incoming = card === this.clone;
        this.animations.push(card.animate(incoming ? [
          {opacity:0.55, transform:'translateY(8px) scale(.97)'},
          {opacity:1, transform:'translateY(0) scale(1)'}
        ] : [
          {opacity:1, transform:'translateY(0) scale(1)'},
          {opacity:0.88, transform:'translateY(-5px) scale(.985)', offset:0.4},
          {opacity:1, transform:'translateY(0) scale(1)'}
        ], {duration, easing:'cubic-bezier(.22,.68,.2,1)', fill:'forwards'}));
      });
      motion.finished.then(() => {
        if(sequence !== this.sequence || !this.isConnected) return;
        if(direction === 1) this.track.append(first); else this.track.prepend(first);
        this.clone.remove(); this.clone = null;
        this.animations.forEach(animation => animation.cancel());
        this.animations = []; this.busy = false;
        this.schedule();
      }).catch(() => {});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kf-card-loop')) {
  customElements.define('kf-card-loop', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('.kf-loop-track');
      if (!this.track) return;
      this.cards = Array.from(this.track.children);
      this.viewport = this.querySelector('.kf-loop-viewport');
      this.controls = this.querySelector('.kf-loop-controls');
      this.button = this.querySelector('.kf-loop-toggle');
      this.label = this.querySelector('[data-loop-label]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.sequence = 0;
      this.visible = true;
      this.userPaused = false;
      this.button.setAttribute('aria-pressed', 'false');
      this.label.textContent = this.dataset.pauseLabel;
      this.hovered = false;
      this.focused = false;
      this.editorPaused = false;
      this.touched = false;
      this.listeners = [];
      const listen = (target, name, fn, options) => {
        target.addEventListener(name, fn, options);
        this.listeners.push(() => target.removeEventListener(name, fn, options));
      };
      const sync = () => this.schedule();
      listen(this, 'pointerenter', e => { if(e.pointerType === 'mouse') { this.hovered = true; this.stop(); } });
      listen(this, 'pointerleave', e => { if(e.pointerType === 'mouse') { this.hovered = false; sync(); } });
      listen(this, 'pointerdown', e => { this.touchStart = e.target.closest('video,button,a,input,select') ? null : e.clientX; this.touched = true; this.stop(); });
      listen(window, 'pointerup', e => { if(this.touched) { this.touched = false; const delta = this.touchStart === null ? 0 : e.clientX - this.touchStart; this.touchStart = null; if(Math.abs(delta) > 40) this.advance(delta < 0 ? 1 : -1, true); else sync(); } });
      listen(window, 'pointercancel', () => { this.touched = false; sync(); });
      listen(this, 'focusin', e => { if(!this.button.contains(e.target)) { this.focused = true; this.stop(); } });
      listen(this, 'focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement) && !this.button.contains(document.activeElement); sync(); }));
      listen(this.button, 'click', () => {
        this.userPaused = !this.userPaused;
        this.button.setAttribute('aria-pressed', String(this.userPaused));
        this.label.textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        if(this.userPaused) this.stop(); else sync();
      });
      listen(document, 'visibilitychange', () => { if(document.hidden) this.stop(); else sync(); });
      listen(this, 'play', () => this.stop(), true);
      listen(this, 'pause', sync, true);
      listen(this, 'ended', sync, true);
      listen(this.reduced, 'change', () => this.configure());
      listen(this, 'shopify:block:select', e => {
        this.editorPaused = true; this.stop();
        const selected = this.cards.find(card => card === e.target || card.contains(e.target));
        if(selected && this.classList.contains('is-ready')) {
          while(this.track.firstElementChild !== selected) this.track.append(this.track.firstElementChild);
        }
      });
      listen(this, 'shopify:block:deselect', () => { this.editorPaused = false; sync(); });
      const section = this.closest('.shopify-section');
      if(section) {
        listen(section, 'shopify:section:select', () => { this.editorPaused = true; this.stop(); });
        listen(section, 'shopify:section:deselect', () => { this.editorPaused = false; sync(); });
      }
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if(this.visible) sync(); else this.stop();
      }, {threshold:0.05});
      this.observer.observe(this);
      this.resizeObserver = new ResizeObserver(() => { this.stop(); sync(); });
      this.resizeObserver.observe(this.viewport);
      this.cleanup = () => {
        this.stop();
        this.listeners.forEach(remove => remove());
        this.observer.disconnect(); this.resizeObserver.disconnect();
        this.cards.forEach(card => this.track.append(card));
        this.classList.remove('is-ready');
        this.cleanup = null;
      };
      this.configure();
    }
    disconnectedCallback() { if(this.cleanup) this.cleanup(); }
    configure() {
      this.stop();
      const enabled = this.dataset.enabled !== 'false' && this.cards.length > 1 && !this.reduced.matches && typeof this.track.animate === 'function';
      this.classList.toggle('is-ready', enabled);
      this.style.setProperty('--kf-loop-columns', Math.min(3, this.cards.length));
      this.controls.hidden = !enabled;
      if(!enabled) this.cards.forEach(card => this.track.append(card));
      this.schedule();
    }
    canRun() {
      return this.isConnected && this.classList.contains('is-ready') && this.visible && !document.hidden && !this.userPaused && !this.hovered && !this.focused && !this.editorPaused && !this.touched && !Array.from(this.querySelectorAll('video')).some(video => !video.paused && !video.ended);
    }
    schedule() {
      clearTimeout(this.timer);
      if(!this.canRun() || this.busy) return;
      this.timer = setTimeout(() => this.advance(), Math.max(2, Number(this.dataset.interval) || 4) * 1000);
    }
    stop() {
      clearTimeout(this.timer);
      this.sequence++;
      this.animations.forEach(animation => animation.cancel());
      this.animations = [];
      if(this.clone) this.clone.remove();
      this.clone = null;
      this.busy = false;
    }
    advance(direction = 1, manual = false) {
      if(this.busy || !this.classList.contains('is-ready') || (!manual && !this.canRun())) return;
      const first = direction === 1 ? this.track.firstElementChild : this.track.lastElementChild;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = first.getBoundingClientRect().width + gap;
      if(distance <= gap) { this.schedule(); return; }
      this.busy = true;
      const sequence = ++this.sequence;
      const duration = Math.max(400, Number(this.dataset.duration) || 1000);
      this.clone = first.cloneNode(true);
      this.clone.setAttribute('aria-hidden', 'true');
      this.clone.setAttribute('inert', '');
      [this.clone, ...this.clone.querySelectorAll('*')].forEach(node => {
        node.removeAttribute('id');
        Array.from(node.attributes).forEach(attr => { if(attr.name.startsWith('data-shopify')) node.removeAttribute(attr.name); });
      });
      this.clone.querySelectorAll('video').forEach(video => { video.removeAttribute('autoplay'); video.removeAttribute('controls'); video.preload = 'none'; });
      if(direction === 1) this.track.append(this.clone); else this.track.prepend(this.clone);
      const frames = [{transform:'translateX(0)'},{transform:`translateX(-${distance}px)`}];
      if(direction === -1) frames.reverse();
      const motion = this.track.animate(frames, {duration, easing:'cubic-bezier(.22,.68,.2,1)', fill:'forwards'});
      this.animations = [motion];
      Array.from(this.track.children).forEach((card, index) => {
        if(index > 4) return;
        const incoming = card === this.clone;
        this.animations.push(card.animate(incoming ? [
          {opacity:0.55, transform:'translateY(8px) scale(.97)'},
          {opacity:1, transform:'translateY(0) scale(1)'}
        ] : [
          {opacity:1, transform:'translateY(0) scale(1)'},
          {opacity:0.88, transform:'translateY(-5px) scale(.985)', offset:0.4},
          {opacity:1, transform:'translateY(0) scale(1)'}
        ], {duration, easing:'cubic-bezier(.22,.68,.2,1)', fill:'forwards'}));
      });
      motion.finished.then(() => {
        if(sequence !== this.sequence || !this.isConnected) return;
        if(direction === 1) this.track.append(first); else this.track.prepend(first);
        this.clone.remove(); this.clone = null;
        this.animations.forEach(animation => animation.cancel());
        this.animations = []; this.busy = false;
        this.schedule();
      }).catch(() => {});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
